
export default {
    name: 'tarif-acte',
    components: {},
    props: {
        assurance_id: Number,
        fields: Array,
        assurance_select: Object,
        editing_acte_tarif_data: Object
    },
    data() {
        return {
            is_printing: false,
            acte_is_loading: true,
            acte_is_empty: false,
            is_error_load: false,

			acte_filter: "",
			perPage: 20,
			print_per_page: -1,
			currentPage: 1,
        }
    },

    watch: {
        assurance_select() {
            const data = {
                assurance_id: this.assurance_select.compagnie_id
            }
            this.getListeActes(data)
        },

        editing_acte_tarif_data() {
            this.saveTarifActe()
        }
    },

    computed: {
        tarification_actes() {
            return this.$store.getters["tarification_actes"];
        },

        acte_length() {
            return this.tarification_actes.length;
        },
    },

    mounted() {
        // Liste des actes
        const data = {
            assurance_id: 0
        }
        this.getListeActes(data)
    },

    methods: {
        getListeActes(data) {
            this.acte_is_loading = true

            this.$store.dispatch('getTarificationActe', data).then(() => {
                if (this.tarification_actes.length > 0) {
                    this.acte_is_empty = false
                } else {
                    this.acte_is_empty = true
                }
                this.acte_is_loading = false
            }).catch(() => {
                this.acte_is_loading = false
                this.is_error_load = true
            })
        },

        edit(data, type_prestation) {
            const tarif_data = {
                data: data,
                type_prestation: type_prestation
            }
            this.$emit('emitTarifActe', tarif_data)
        },

        saveTarifActe() {
            this.$store.dispatch("saveTarifActe", this.editing_acte_tarif_data).then((response) => {
                if (response.success) {
                    const data = {
                        assurance_id: this.assurance_select.compagnie_id
                    }
                    this.getListeActes(data)

                    this.$emit('emitCloseTarifModal')
                } else {
                    if (response.code == 401) {
                        this.errorToast("Une erreur s'est produite ! Merci de réessayer plustard.")
                    } else if (response.code == 500) {
                        this.errorToast("Une erreur s'est produite !")
                    }
                }
                this.save_loading = false
                this.btn_disable = false
            })
        }
    }
}